<template>
  <TooltipIconButton
    icon="mdi-download"
    tooltipText="tooltip.download"
    :color="color"
    :defaultColor="defaultColor"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
export default {
  name: 'DownloadButton',
  props: {
    color: {
      type: String,
      default: 'red',
    },
    defaultColor: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
